import useNotifications from '@anm/hooks/useNotifications';
import { VideoStatusCode } from '@anm/hosting-player';

import { UploadPosterState } from '../../../../store/modules/hostedVideo';
import NOTIFICATION_MESSAGES from '../notificationMessages';

const errors: Record<string, string> = {
  [VideoStatusCode.in_process]: 'Uploaded poster is too big, limit is 10 MB',
  [VideoStatusCode.default]: NOTIFICATION_MESSAGES['errorMessage']
};

const useUploadPosterNotifications = (entity: UploadPosterState) => {
  const isErrorCode = entity.error && errors[entity.error.code];
  const errorMessage = isErrorCode ? errors[entity.error!.code] : errors.default;

  const { notifications } = useNotifications({
    ...entity,
    ...NOTIFICATION_MESSAGES,
    errorMessage
  });

  const notificationExceptSuccess = notifications.filter(n => n.type !== 'success');

  return notificationExceptSuccess;
};

export default useUploadPosterNotifications;
